import { render, staticRenderFns } from "./TickerVertical.vue?vue&type=template&id=354839a6&scoped=true"
import script from "./TickerVertical.vue?vue&type=script&lang=js"
export * from "./TickerVertical.vue?vue&type=script&lang=js"
import style0 from "./TickerVertical.vue?vue&type=style&index=0&id=354839a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "354839a6",
  null
  
)

export default component.exports